import { urlFor } from 'scrivito'
import { SchemaWidgetInstance } from '../SchemaWidgetClass'
import { postalAddressJson } from './postalAddressJsonLd'

export const educationalOrganizationJson = (
  data: SchemaWidgetInstance,
  _page: unknown
) => {
  const logo = data.get('logo')
  const imageUrl = logo ? urlFor(logo) : null

  return {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: data.get('name'),
    description: data.get('description'),
    url: data.get('url'),
    telephone: data.get('telephone'),
    email: data.get('email'),
    location: postalAddressJson(data, null),
    logo: imageUrl,
    parentOrganization: {
      '@type': 'CollegeOrUniversity',
      name: 'Hochschule Heilbronn',
      url: 'https://www.hs-heilbronn.de',
    },
  }
}
